import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import merge from "lodash/merge";
import { SocialMediaType } from "./types/user.types";
import { extractFromFullName, handle } from "@dp/common";
import moment from "moment-timezone";
var PAYLOAD_CONSTANTS = {
  JAVA_UTIL_HASHMAP: "java.util.HashMap",
  CREDIT_CARD_BEAN: "com.darden.commerce.order.purchase.CreditCardBean"
};

var User = /*#__PURE__*/function () {
  function User(config, axios) {
    _classCallCheck(this, User);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    _defineProperty(this, "_lastSessionDetailTimeStamp", 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(User, [{
    key: "getSessionDetails",
    value: function () {
      var _getSessionDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(page, contentName, contentLinkName, showLogout) {
        var response, data, _successResp$currentT, successResp;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.axios.get(this.config.postfix.SESSION_DETAILS, {
                  params: {
                    fromPage: page,
                    headerContentName: contentName,
                    headerContentLinkName: contentLinkName,
                    headerContentShowLogout: showLogout
                  }
                });

              case 2:
                response = _context.sent;
                data = response.data;

                if (!data.errorResponse) {
                  _context.next = 8;
                  break;
                }

                throw data.errorResponse;

              case 8:
                this._lastSessionDetailTimeStamp = Date.now();
                successResp = data.successResponse;
                return _context.abrupt("return", merge(data, {
                  successResponse: {
                    currentTime: {
                      dateTime: (_successResp$currentT = successResp.currentTime) !== null && _successResp$currentT !== void 0 && _successResp$currentT.time ? moment(successResp.currentTime.time).toDate() : null
                    },
                    sessionContext: {
                      actualPickupDateTime: successResp.sessionContext.actualPickupDate && successResp.sessionContext.actualPickupTime ? moment(successResp.sessionContext.actualPickupDate + " " + successResp.sessionContext.actualPickupTime).toDate() : null,
                      updated_EDateTime: successResp.sessionContext.updated_EDate && successResp.sessionContext.updated_ETime ? moment(successResp.sessionContext.updated_EDate + " " + successResp.sessionContext.updated_ETime).toDate() : null
                    }
                  }
                }));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getSessionDetails(_x, _x2, _x3, _x4) {
        return _getSessionDetails.apply(this, arguments);
      }

      return getSessionDetails;
    }()
  }, {
    key: "loginAndGetUserProfile",
    value: function () {
      var _loginAndGetUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(userName, password) {
        var saveCardToProfile,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                saveCardToProfile = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
                _context2.next = 3;
                return this.login(userName, password, saveCardToProfile);

              case 3:
                return _context2.abrupt("return", this.getCurrentUserProfile());

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loginAndGetUserProfile(_x5, _x6) {
        return _loginAndGetUserProfile.apply(this, arguments);
      }

      return loginAndGetUserProfile;
    }()
  }, {
    key: "socialLoginAndGetUserProfile",
    value: function () {
      var _socialLoginAndGetUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(userName, password) {
        var saveCardToProfile,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                saveCardToProfile = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : false;
                _context3.next = 3;
                return this.socialLogin(userName, password, saveCardToProfile);

              case 3:
                return _context3.abrupt("return", this.getCurrentUserProfile());

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function socialLoginAndGetUserProfile(_x7, _x8) {
        return _socialLoginAndGetUserProfile.apply(this, arguments);
      }

      return socialLoginAndGetUserProfile;
    }()
  }, {
    key: "getFacebookUserInfo",
    value: function () {
      var _getFacebookUserInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(accessToken) {
        var _userInfo$picture;

        var response, userInfo, name;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.axios.get(this.config.postfix.FACEBOOK_USER_INFO_API, {
                  params: {
                    access_token: accessToken
                  }
                });

              case 2:
                response = _context4.sent;
                userInfo = response.data;
                name = extractFromFullName(userInfo.name);
                return _context4.abrupt("return", {
                  type: SocialMediaType.GOOGLEPLUS,
                  id: userInfo.id,
                  email: userInfo.email,
                  picture: (_userInfo$picture = userInfo.picture) === null || _userInfo$picture === void 0 ? void 0 : _userInfo$picture.data,
                  firstName: name.first,
                  lastName: name.last
                });

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getFacebookUserInfo(_x9) {
        return _getFacebookUserInfo.apply(this, arguments);
      }

      return getFacebookUserInfo;
    }()
  }, {
    key: "getGoogleUserInfo",
    value: function () {
      var _getGoogleUserInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(accessToken) {
        var response, userInfo;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.axios.get(this.config.postfix.GOOGLE_USER_INFO_API, {
                  params: {
                    access_token: accessToken
                  }
                });

              case 2:
                response = _context5.sent;
                userInfo = response.data;
                return _context5.abrupt("return", {
                  type: SocialMediaType.GOOGLEPLUS,
                  id: userInfo.id,
                  email: userInfo.email,
                  picture: {
                    url: userInfo.picture
                  },
                  firstName: userInfo.given_name,
                  lastName: userInfo.family_name
                });

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getGoogleUserInfo(_x10) {
        return _getGoogleUserInfo.apply(this, arguments);
      }

      return getGoogleUserInfo;
    }()
  }, {
    key: "saveGiftCardToProfile",
    value: function () {
      var _saveGiftCardToProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(giftCardNumber, giftCardName) {
        var _data$successResponse;

        var gcNumber, resp, data, giftCards;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                gcNumber = giftCardNumber ? giftCardNumber.split("-").join("") : giftCardNumber;
                _context6.next = 3;
                return this.axios.post(this.config.postfix.SAVE_GIFT_CARD, {
                  giftCardNumber: gcNumber,
                  giftCardName: giftCardName,
                  saveGCProfileApi: true
                });

              case 3:
                resp = _context6.sent;
                data = resp.data;
                giftCards = data === null || data === void 0 ? void 0 : (_data$successResponse = data.successResponse) === null || _data$successResponse === void 0 ? void 0 : _data$successResponse.giftCards;

                if (!giftCards) {
                  _context6.next = 14;
                  break;
                }

                if (!Array.isArray(giftCards)) {
                  _context6.next = 11;
                  break;
                }

                return _context6.abrupt("return", giftCards);

              case 11:
                return _context6.abrupt("return", [giftCards]);

              case 12:
                _context6.next = 15;
                break;

              case 14:
                return _context6.abrupt("return", null);

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function saveGiftCardToProfile(_x11, _x12) {
        return _saveGiftCardToProfile.apply(this, arguments);
      }

      return saveGiftCardToProfile;
    }()
  }, {
    key: "socialLogin",
    value: function () {
      var _socialLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(socialUID, socialEmail) {
        var _resp$data;

        var saveCardToProfile,
            commonQueryParams,
            conceptCode,
            locale,
            resp,
            _args7 = arguments;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                saveCardToProfile = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : false;
                commonQueryParams = this.config.getCommonQueryParams();
                conceptCode = this.config.getConceptCode();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context7.next = 6;
                return this.axios.post(this.config.postfix.LOGIN, {
                  socialUID: socialUID,
                  socialEmail: socialEmail,
                  saveCardToProfile: saveCardToProfile,
                  locale: locale
                }, {
                  params: {
                    conceptCode: conceptCode
                  },
                  headers: {
                    enc: "true"
                  }
                });

              case 6:
                resp = _context7.sent;
                return _context7.abrupt("return", (_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : _resp$data.successResponse);

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function socialLogin(_x13, _x14) {
        return _socialLogin.apply(this, arguments);
      }

      return socialLogin;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var resp;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.axios.post(this.config.postfix.LOGOUT);

              case 2:
                resp = _context8.sent;
                return _context8.abrupt("return", resp.data);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(userName, password) {
        var _resp$data2;

        var saveCardToProfile,
            commonQueryParams,
            locale,
            resp,
            _args9 = arguments;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                saveCardToProfile = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : false;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context9.next = 5;
                return this.axios.post(this.config.postfix.LOGIN, {
                  login: userName,
                  password: password,
                  saveCardToProfile: saveCardToProfile,
                  locale: locale
                }, {
                  headers: {
                    enc: "true"
                  }
                });

              case 5:
                resp = _context9.sent;
                return _context9.abrupt("return", (_resp$data2 = resp.data) === null || _resp$data2 === void 0 ? void 0 : _resp$data2.successResponse);

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function login(_x15, _x16) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "signUp",
    value: function () {
      var _signUp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(createAccountData) {
        var _createAccountData$sa, _createAccountData$mi, _createAccountData$su, _createAccountData$re, _createAccountData$re2, _createAccountData$se, _createAccountData$se2, _createAccountData$so, _createAccountData$so2, _createAccountData$so3, _resp$data3;

        var commonQueryParams, locale, signUpData, resp;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                signUpData = {
                  login: createAccountData.email,
                  confirmLogin: createAccountData.email,
                  salutation: (_createAccountData$sa = createAccountData.salutation) !== null && _createAccountData$sa !== void 0 ? _createAccountData$sa : "",
                  firstName: createAccountData.firstName,
                  lastName: createAccountData.lastName,
                  middleName: (_createAccountData$mi = createAccountData.middleName) !== null && _createAccountData$mi !== void 0 ? _createAccountData$mi : "",
                  suffix: (_createAccountData$su = createAccountData.suffix) !== null && _createAccountData$su !== void 0 ? _createAccountData$su : "",
                  channel: this.config.getDardenChannel().appChannel,
                  signupSource: this.config.getSignUpSource().appSource,
                  Phone: {
                    "atg-rest-class-type": PAYLOAD_CONSTANTS.JAVA_UTIL_HASHMAP,
                    "atg-rest-values": {
                      phone: createAccountData.phone,
                      phoneExt: "",
                      phoneType: "Mobile"
                    }
                  },
                  Address: {
                    "atg-rest-class-type": PAYLOAD_CONSTANTS.JAVA_UTIL_HASHMAP,
                    "atg-rest-values": {
                      addressLine1: (_createAccountData$re = createAccountData.restaurantAddressLine1) !== null && _createAccountData$re !== void 0 ? _createAccountData$re : "",
                      addressLine2: (_createAccountData$re2 = createAccountData.restaurantAddressLine2) !== null && _createAccountData$re2 !== void 0 ? _createAccountData$re2 : "",
                      addressType: createAccountData.restaurantAddressType,
                      city: createAccountData.restaurantCity,
                      state: createAccountData.restaurantState,
                      zip: createAccountData.restaurantZip,
                      country: createAccountData.restaurantCountry
                    }
                  },
                  dobMonth: createAccountData.dobMonth,
                  dobDay: createAccountData.dobDay,
                  dobYear: createAccountData.dobYear,
                  password: createAccountData.password,
                  confirmpassword: createAccountData.password,
                  securityQuestion: (_createAccountData$se = createAccountData.securityQuestion) !== null && _createAccountData$se !== void 0 ? _createAccountData$se : "null",
                  securityAnswer: (_createAccountData$se2 = createAccountData.securityAnswer) !== null && _createAccountData$se2 !== void 0 ? _createAccountData$se2 : "null",
                  registeredConceptID: this.config.getSiteIds().siteId,
                  guestType: createAccountData.guestType,
                  locale: locale,
                  preferredRestaurantId: createAccountData.preferredRestaurantId,
                  conceptCode: "",
                  socialUID: (_createAccountData$so = createAccountData.socialUID) !== null && _createAccountData$so !== void 0 ? _createAccountData$so : "",
                  socialEmail: (_createAccountData$so2 = createAccountData.socialEmail) !== null && _createAccountData$so2 !== void 0 ? _createAccountData$so2 : "",
                  mobilePay: createAccountData.mobilePay ? "true" : "false",
                  retainCard: createAccountData.retainCard ? "true" : "false",
                  primaryEmailOptin: createAccountData.primaryEmailOptin,
                  socialMediaType: (_createAccountData$so3 = createAccountData.socialMediaType) !== null && _createAccountData$so3 !== void 0 ? _createAccountData$so3 : ""
                };
                _context10.next = 5;
                return this.axios.post(this.config.postfix.SIGNUP, signUpData, {
                  params: {
                    locale: locale
                  }
                });

              case 5:
                resp = _context10.sent;
                return _context10.abrupt("return", (_resp$data3 = resp.data) === null || _resp$data3 === void 0 ? void 0 : _resp$data3.successResponse);

              case 7:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function signUp(_x17) {
        return _signUp.apply(this, arguments);
      }

      return signUp;
    }()
  }, {
    key: "signUpAndGetUserProfile",
    value: function () {
      var _signUpAndGetUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(createAccountDate) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.signUp(createAccountDate);

              case 2:
                return _context11.abrupt("return", this.getCurrentUserProfile());

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function signUpAndGetUserProfile(_x18) {
        return _signUpAndGetUserProfile.apply(this, arguments);
      }

      return signUpAndGetUserProfile;
    }()
  }, {
    key: "performSocialLink",
    value: function performSocialLink(email, socialUID, socialMediaType) {
      var commonQueryParams = this.config.getCommonQueryParams();
      var locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
      return this.axios.post(this.config.postfix.SOCIAL_LINK, {
        locale: locale,
        login: email,
        socialUID: socialUID,
        socialEmail: email,
        socialMediaType: socialMediaType
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "getCurrentUserProfile",
    value: function () {
      var _getCurrentUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var _resp$data4;

        var resp;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.axios.get(this.config.postfix.PROFILE);

              case 2:
                resp = _context12.sent;
                return _context12.abrupt("return", (_resp$data4 = resp.data) === null || _resp$data4 === void 0 ? void 0 : _resp$data4.successResponse);

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getCurrentUserProfile() {
        return _getCurrentUserProfile.apply(this, arguments);
      }

      return getCurrentUserProfile;
    }()
  }, {
    key: "getOrderHistory",
    value: function () {
      var _getOrderHistory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var startIndex,
            numOrders,
            expiryDays,
            _response$data,
            _response$data$succes,
            response,
            _args13 = arguments;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                startIndex = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : 0;
                numOrders = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : 10;
                expiryDays = _args13.length > 2 && _args13[2] !== undefined ? _args13[2] : 365;
                _context13.prev = 3;
                _context13.next = 6;
                return this.axios.get(this.config.postfix.ORDER_HISTORY_API, {
                  params: {
                    startIndex: startIndex,
                    numOrders: numOrders,
                    expiryDays: expiryDays
                  }
                });

              case 6:
                response = _context13.sent;
                return _context13.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$succes = _response$data.successResponse) === null || _response$data$succes === void 0 ? void 0 : _response$data$succes.OrderSummary);

              case 10:
                _context13.prev = 10;
                _context13.t0 = _context13["catch"](3);
                return _context13.abrupt("return", []);

              case 13:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[3, 10]]);
      }));

      function getOrderHistory() {
        return _getOrderHistory.apply(this, arguments);
      }

      return getOrderHistory;
    }()
  }, {
    key: "saveCreditCard",
    value: function () {
      var _saveCreditCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(creditCardData, action) {
        var _response$data2;

        var commonQueryParams, locale, creditCardBasicData, isAccepted, isDefault, nameOnCard, billingAddress, firstName, lastName, address1, address2, city, postalCode, state, country, userId, email, cardDetails, payload, response;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                creditCardBasicData = creditCardData.creditCardBasicData, isAccepted = creditCardData.isAccepted, isDefault = creditCardData.isDefault, nameOnCard = creditCardData.nameOnCard, billingAddress = creditCardData.billingAddress, firstName = creditCardData.firstName, lastName = creditCardData.lastName;
                address1 = billingAddress.address1, address2 = billingAddress.address2, city = billingAddress.city, postalCode = billingAddress.postalCode, state = billingAddress.state, country = billingAddress.country;
                userId = creditCardBasicData.userId, email = creditCardBasicData.email, cardDetails = _objectWithoutProperties(creditCardBasicData, ["userId", "email"]);
                payload = {
                  locale: locale,
                  conceptCode: this.config.getConceptCode(),
                  login: email,
                  transactionDetails: {
                    "atg-rest-class-type": PAYLOAD_CONSTANTS.JAVA_UTIL_HASHMAP,
                    "atg-rest-class-descriptor": {
                      "atg-rest-values": {
                        "container-class": PAYLOAD_CONSTANTS.JAVA_UTIL_HASHMAP,
                        "element-class": {
                          "container-class": PAYLOAD_CONSTANTS.JAVA_UTIL_HASHMAP,
                          "element-class": PAYLOAD_CONSTANTS.CREDIT_CARD_BEAN
                        }
                      }
                    },
                    "atg-rest-values": {
                      action: action,
                      isDefault: isDefault ? "true" : "false",
                      defaultCreditCard: _objectSpread(_objectSpread({
                        "atg-rest-class-type": PAYLOAD_CONSTANTS.CREDIT_CARD_BEAN
                      }, cardDetails), {}, {
                        nameOnCard: nameOnCard,
                        isAccepted: isAccepted ? "true" : "false",
                        acceptClientType: "app-profile-addcard",
                        billingAddress: {
                          "atg-rest-class-type": "atg.core.util.Address",
                          firstName: firstName,
                          lastName: lastName,
                          address1: address1,
                          address2: address2,
                          city: city,
                          state: state,
                          postalCode: postalCode,
                          country: country
                        }
                      })
                    }
                  }
                };
                _context14.next = 8;
                return this.axios.post(this.config.postfix.UPDATE_PROFILE, payload, {
                  params: {
                    userId: userId
                  }
                });

              case 8:
                response = _context14.sent;
                return _context14.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.successResponse);

              case 10:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function saveCreditCard(_x19, _x20) {
        return _saveCreditCard.apply(this, arguments);
      }

      return saveCreditCard;
    }()
  }, {
    key: "saveCreditCardToUserProfile",
    value: function saveCreditCardToUserProfile(creditCardData) {
      return this.saveCreditCard(creditCardData, "Add");
    }
  }, {
    key: "updateCreditCardAndSaveToUserProfile",
    value: function updateCreditCardAndSaveToUserProfile(creditCardData) {
      return this.saveCreditCard(creditCardData, "Update");
    }
  }, {
    key: "deleteCreditCard",
    value: function () {
      var _deleteCreditCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(creditCardData) {
        var _response$data3;

        var commonQueryParams, locale, creditCardType, paymentCardToken, email, userId, payload, response;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                creditCardType = creditCardData.creditCardType, paymentCardToken = creditCardData.paymentCardToken, email = creditCardData.email, userId = creditCardData.userId;
                payload = {
                  locale: locale,
                  conceptCode: this.config.getConceptCode(),
                  login: email,
                  transactionDetails: {
                    "atg-rest-class-type": PAYLOAD_CONSTANTS.JAVA_UTIL_HASHMAP,
                    "atg-rest-class-descriptor": {
                      "atg-rest-values": {
                        "container-class": PAYLOAD_CONSTANTS.JAVA_UTIL_HASHMAP,
                        "element-class": {
                          "container-class": PAYLOAD_CONSTANTS.JAVA_UTIL_HASHMAP,
                          "element-class": PAYLOAD_CONSTANTS.CREDIT_CARD_BEAN
                        }
                      }
                    },
                    "atg-rest-values": {
                      action: "Remove",
                      defaultCreditCard: {
                        "atg-rest-class-type": PAYLOAD_CONSTANTS.CREDIT_CARD_BEAN,
                        paymentCardToken: paymentCardToken,
                        creditCardType: creditCardType
                      }
                    }
                  }
                };
                _context15.next = 6;
                return this.axios.post(this.config.postfix.UPDATE_PROFILE, payload, {
                  params: {
                    userId: userId
                  }
                });

              case 6:
                response = _context15.sent;
                return _context15.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.successResponse);

              case 8:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function deleteCreditCard(_x21) {
        return _deleteCreditCard.apply(this, arguments);
      }

      return deleteCreditCard;
    }()
  }, {
    key: "deleteCreditCardFromUserProfile",
    value: function deleteCreditCardFromUserProfile(creditCardData) {
      return this.deleteCreditCard(creditCardData);
    }
  }, {
    key: "rateVisit",
    value: function () {
      var _rateVisit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(params) {
        var _resp$data5;

        var resp;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.axios.post(this.config.postfix.RATE_YOUR_VISIT, _objectSpread({}, params));

              case 2:
                resp = _context16.sent;
                return _context16.abrupt("return", resp === null || resp === void 0 ? void 0 : (_resp$data5 = resp.data) === null || _resp$data5 === void 0 ? void 0 : _resp$data5.successResponse);

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function rateVisit(_x22) {
        return _rateVisit.apply(this, arguments);
      }

      return rateVisit;
    }()
  }, {
    key: "updateProfile",
    value: function () {
      var _updateProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(payload, userId) {
        var _resp$data6;

        var commonQueryParams, locale, reqBody, resp;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                reqBody = _objectSpread(_objectSpread({}, payload), {}, {
                  locale: locale,
                  conceptCode: this.config.getConceptCode()
                });
                _context17.next = 5;
                return this.axios.post(this.config.postfix.UPDATE_PROFILE, reqBody, {
                  params: {
                    userId: userId
                  }
                });

              case 5:
                resp = _context17.sent;
                return _context17.abrupt("return", (_resp$data6 = resp.data) === null || _resp$data6 === void 0 ? void 0 : _resp$data6.successResponse);

              case 7:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function updateProfile(_x23, _x24) {
        return _updateProfile.apply(this, arguments);
      }

      return updateProfile;
    }()
  }, {
    key: "updateUserPassword",
    value: function () {
      var _updateUserPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(payload) {
        var _resp$data7;

        var commonQueryParams, locale, reqBody, resp;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                reqBody = _objectSpread(_objectSpread({}, payload), {}, {
                  locale: locale,
                  conceptCode: this.config.getConceptCode()
                });
                _context18.next = 5;
                return this.axios.post(this.config.postfix.CHANGE_PASSWORD, reqBody);

              case 5:
                resp = _context18.sent;
                return _context18.abrupt("return", (_resp$data7 = resp.data) === null || _resp$data7 === void 0 ? void 0 : _resp$data7.successResponse);

              case 7:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function updateUserPassword(_x25) {
        return _updateUserPassword.apply(this, arguments);
      }

      return updateUserPassword;
    }()
  }, {
    key: "getSettingsList",
    value: function () {
      var _getSettingsList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(settingType) {
        var commonQueryParams, locale, conceptCode, resp;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                conceptCode = this.config.getConceptCode();
                _context19.prev = 3;
                _context19.next = 6;
                return this.axios.get("".concat(this.config.postfix.GET_SETTING_DATA_API, "/").concat(settingType, "?conceptCode=").concat(conceptCode, "&locale=").concat(locale, "&channel=mobileapp"));

              case 6:
                resp = _context19.sent;
                return _context19.abrupt("return", resp.data);

              case 10:
                _context19.prev = 10;
                _context19.t0 = _context19["catch"](3);
                console.log(_context19.t0);

              case 13:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[3, 10]]);
      }));

      function getSettingsList(_x26) {
        return _getSettingsList.apply(this, arguments);
      }

      return getSettingsList;
    }()
  }, {
    key: "updateFirstName",
    value: function updateFirstName(payload, userId) {
      return this.updateProfile(payload, userId);
    }
  }, {
    key: "updatePhoneNumber",
    value: function updatePhoneNumber(payload, userId) {
      return this.updateProfile(payload, userId);
    }
  }, {
    key: "updateEmailAddress",
    value: function updateEmailAddress(payload, userId) {
      return this.updateProfile(payload, userId);
    }
  }, {
    key: "updateSecurityQuestionAnswer",
    value: function () {
      var _updateSecurityQuestionAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(payload, userId) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.abrupt("return", this.updateProfile(payload, userId));

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function updateSecurityQuestionAnswer(_x27, _x28) {
        return _updateSecurityQuestionAnswer.apply(this, arguments);
      }

      return updateSecurityQuestionAnswer;
    }()
  }, {
    key: "updateLastName",
    value: function () {
      var _updateLastName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(userProfileData, userId) {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                return _context21.abrupt("return", this.updateProfile(userProfileData, userId));

              case 1:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function updateLastName(_x29, _x30) {
        return _updateLastName.apply(this, arguments);
      }

      return updateLastName;
    }()
  }, {
    key: "updatePassword",
    value: function () {
      var _updatePassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(userProfileData) {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt("return", this.updateUserPassword(userProfileData));

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function updatePassword(_x31) {
        return _updatePassword.apply(this, arguments);
      }

      return updatePassword;
    }()
  }, {
    key: "updateDob",
    value: function () {
      var _updateDob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(userProfileData, userId) {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                return _context23.abrupt("return", this.updateProfile(userProfileData, userId));

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function updateDob(_x32, _x33) {
        return _updateDob.apply(this, arguments);
      }

      return updateDob;
    }()
  }, {
    key: "resetPasswordRequest",
    value: function () {
      var _resetPasswordRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(payload) {
        var _resp$data8;

        var commonQueryParams, locale, reqBody, resp;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                reqBody = _objectSpread(_objectSpread({}, payload), {}, {
                  locale: locale,
                  conceptCode: this.config.getConceptCode()
                });
                _context24.next = 5;
                return this.axios.post(this.config.postfix.RESET_PASSWORD_REQUEST, reqBody);

              case 5:
                resp = _context24.sent;
                return _context24.abrupt("return", (_resp$data8 = resp.data) === null || _resp$data8 === void 0 ? void 0 : _resp$data8.successResponse);

              case 7:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function resetPasswordRequest(_x34) {
        return _resetPasswordRequest.apply(this, arguments);
      }

      return resetPasswordRequest;
    }()
  }, {
    key: "resetPassword",
    value: function () {
      var _resetPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(payload) {
        var _resp$data9;

        var commonQueryParams, locale, reqBody, resp;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                reqBody = _objectSpread(_objectSpread({}, payload), {}, {
                  locale: locale,
                  conceptCode: this.config.getConceptCode()
                });
                _context25.next = 5;
                return this.axios.post(this.config.postfix.RESET_PASSWORD, reqBody);

              case 5:
                resp = _context25.sent;
                return _context25.abrupt("return", (_resp$data9 = resp.data) === null || _resp$data9 === void 0 ? void 0 : _resp$data9.successResponse);

              case 7:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function resetPassword(_x35) {
        return _resetPassword.apply(this, arguments);
      }

      return resetPassword;
    }()
  }, {
    key: "updateFavoriteLocation",
    value: function () {
      var _updateFavoriteLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(favoriteLocationData, userId) {
        var email, favouriteLocationAction, restaurantIdentifier, payload;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                email = favoriteLocationData.email, favouriteLocationAction = favoriteLocationData.favouriteLocationAction, restaurantIdentifier = favoriteLocationData.restaurantIdentifier;
                payload = {
                  login: email,
                  favoriteLocation: {
                    "atg-rest-class-type": PAYLOAD_CONSTANTS.JAVA_UTIL_HASHMAP,
                    "atg-rest-values": {
                      restaurantIdentifier: restaurantIdentifier,
                      favouriteLocationAction: favouriteLocationAction
                    }
                  }
                };
                return _context26.abrupt("return", this.updateProfile(payload, userId));

              case 3:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function updateFavoriteLocation(_x36, _x37) {
        return _updateFavoriteLocation.apply(this, arguments);
      }

      return updateFavoriteLocation;
    }()
  }, {
    key: "getSettings",
    value: function () {
      var _getSettings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(type) {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                return _context27.abrupt("return", this.getSettingsList(type));

              case 1:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function getSettings(_x38) {
        return _getSettings.apply(this, arguments);
      }

      return getSettings;
    }()
  }, {
    key: "getRecentOrderDetailsForNonLoggedinUser",
    value: function () {
      var _getRecentOrderDetailsForNonLoggedinUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(data) {
        var conceptCode, commonQueryParams, locale, payload, response;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                conceptCode = this.config.getConceptCode();
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                payload = {
                  ordersInfo: {
                    "atg-rest-class-type": "java.util.ArrayList",
                    "atg-rest-class-descriptor": {
                      "atg-rest-values": {
                        "container-class": "java.util.ArrayList",
                        "element-class": "com.darden.commerce.order.OrdersInfo"
                      }
                    },
                    "atg-rest-values": data
                  }
                };
                _context28.prev = 4;
                _context28.next = 7;
                return this.axios.post(this.config.postfix.ORDER_DETAILS, payload, {
                  params: {
                    conceptCode: conceptCode,
                    locale: locale
                  },
                  headers: {
                    "x-retry-on-timeout": true
                  }
                });

              case 7:
                response = _context28.sent;
                return _context28.abrupt("return", response.data.successResponse);

              case 11:
                _context28.prev = 11;
                _context28.t0 = _context28["catch"](4);
                return _context28.abrupt("return", null);

              case 14:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this, [[4, 11]]);
      }));

      function getRecentOrderDetailsForNonLoggedinUser(_x39) {
        return _getRecentOrderDetailsForNonLoggedinUser.apply(this, arguments);
      }

      return getRecentOrderDetailsForNonLoggedinUser;
    }()
  }, {
    key: "decryptLegacyEncryptedData",
    value: function () {
      var _decryptLegacyEncryptedData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(data) {
        var xmlenc, xmlencOpts;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                // XML Response
                xmlenc = this.config.getMessageEncryptionUtil();
                xmlencOpts = this.config.getMessageEncryptionOpts();

                if (!(xmlenc && xmlencOpts && typeof xmlenc.decryptPayload === "function")) {
                  _context30.next = 6;
                  break;
                }

                return _context30.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(resolve, reject) {
                    var _yield$handle, _yield$handle2, error, decryptedResponse;

                    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
                      while (1) {
                        switch (_context29.prev = _context29.next) {
                          case 0:
                            _context29.next = 2;
                            return handle(xmlenc.decryptPayload(data, xmlencOpts.privateKey));

                          case 2:
                            _yield$handle = _context29.sent;
                            _yield$handle2 = _slicedToArray(_yield$handle, 2);
                            error = _yield$handle2[0];
                            decryptedResponse = _yield$handle2[1];

                            if (error) {
                              reject("unable to decrypt" + error);
                            } else {
                              resolve(decryptedResponse);
                            }

                          case 7:
                          case "end":
                            return _context29.stop();
                        }
                      }
                    }, _callee29);
                  }));

                  return function (_x41, _x42) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 6:
                return _context30.abrupt("return", null);

              case 7:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function decryptLegacyEncryptedData(_x40) {
        return _decryptLegacyEncryptedData.apply(this, arguments);
      }

      return decryptLegacyEncryptedData;
    }()
  }, {
    key: "lastSessionDetailTimeStamp",
    get: function get() {
      return this._lastSessionDetailTimeStamp;
    }
  }]);

  return User;
}();

export { User as default };